import { render, staticRenderFns } from "./section9.vue?vue&type=template&id=367d3e47"
import script from "./section9.vue?vue&type=script&lang=js"
export * from "./section9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports